module.exports = __webpack_public_path__ + "static/placeholderPT-d55677de2f174e60eb1389de0fab09e9.jpg";